const UK_GEOGRAPHY = {
  England: {
    regions: {
      'North East': {
        councils: [
          'County Durham', 'Darlington', 'Gateshead', 'Hartlepool', 'Middlesbrough',
          'Newcastle upon Tyne', 'North Tyneside', 'Northumberland', 'Redcar and Cleveland',
          'South Tyneside', 'Stockton-on-Tees', 'Sunderland'
        ]
      },
      'North West': {
        councils: [
          'Blackburn with Darwen', 'Blackpool', 'Bolton', 'Bury', 'Cheshire East',
          'Cheshire West and Chester', 'Cumbria', 'Halton', 'Knowsley', 'Lancashire',
          'Liverpool', 'Manchester', 'Oldham', 'Rochdale', 'Salford', 'Sefton',
          'St Helens', 'Stockport', 'Tameside', 'Trafford', 'Warrington', 'Wigan', 'Wirral'
        ]
      },
      'Yorkshire and The Humber': {
        councils: [
          'Barnsley', 'Bradford', 'Calderdale', 'Doncaster', 'East Riding of Yorkshire',
          'Kingston upon Hull', 'Kirklees', 'Leeds', 'North East Lincolnshire',
          'North Lincolnshire', 'North Yorkshire', 'Rotherham', 'Sheffield',
          'Wakefield', 'York'
        ]
      },
      'East Midlands': {
        councils: [
          'Derby', 'Derbyshire', 'Leicester', 'Leicestershire', 'Lincolnshire',
          'Northamptonshire', 'Nottingham', 'Nottinghamshire', 'Rutland'
        ]
      },
      'West Midlands': {
        councils: [
          'Birmingham', 'Coventry', 'Dudley', 'Herefordshire', 'Sandwell',
          'Shropshire', 'Solihull', 'Staffordshire', 'Stoke-on-Trent', 'Telford and Wrekin',
          'Walsall', 'Warwickshire', 'Wolverhampton', 'Worcestershire'
        ]
      },
      'East of England': {
        councils: [
          'Bedford', 'Cambridgeshire', 'Central Bedfordshire', 'Essex', 'Hertfordshire',
          'Luton', 'Norfolk', 'Peterborough', 'Southend-on-Sea', 'Suffolk', 'Thurrock'
        ]
      },
      'London': {
        councils: [
          'Barking and Dagenham', 'Barnet', 'Bexley', 'Brent', 'Bromley', 'Camden',
          'City of London', 'Croydon', 'Ealing', 'Enfield', 'Greenwich', 'Hackney',
          'Hammersmith and Fulham', 'Haringey', 'Harrow', 'Havering', 'Hillingdon',
          'Hounslow', 'Islington', 'Kensington and Chelsea', 'Kingston upon Thames',
          'Lambeth', 'Lewisham', 'Merton', 'Newham', 'Redbridge', 'Richmond upon Thames',
          'Southwark', 'Sutton', 'Tower Hamlets', 'Waltham Forest', 'Wandsworth', 'Westminster'
        ]
      },
      'South East': {
        councils: [
          'Bracknell Forest', 'Brighton and Hove', 'Buckinghamshire', 'East Sussex',
          'Hampshire', 'Isle of Wight', 'Kent', 'Medway', 'Milton Keynes', 'Oxfordshire',
          'Portsmouth', 'Reading', 'Slough', 'Southampton', 'Surrey', 'West Berkshire',
          'West Sussex', 'Windsor and Maidenhead', 'Wokingham'
        ]
      },
      'South West': {
        councils: [
          'Bath and North East Somerset', 'Bournemouth, Christchurch and Poole', 'Bristol',
          'Cornwall', 'Devon', 'Dorset', 'Gloucestershire', 'Isles of Scilly',
          'North Somerset', 'Plymouth', 'Somerset', 'South Gloucestershire',
          'Swindon', 'Torbay', 'Wiltshire'
        ]
      }
    }
  },
  Wales: {
    regions: {
      'North Wales': {
        councils: [
          'Anglesey', 'Conwy', 'Denbighshire', 'Flintshire', 'Gwynedd', 'Wrexham'
        ]
      },
      'Mid Wales': {
        councils: [
          'Ceredigion', 'Powys'
        ]
      },
      'South West Wales': {
        councils: [
          'Carmarthenshire', 'Neath Port Talbot', 'Pembrokeshire', 'Swansea'
        ]
      },
      'South East Wales': {
        councils: [
          'Blaenau Gwent', 'Bridgend', 'Caerphilly', 'Cardiff', 'Merthyr Tydfil',
          'Monmouthshire', 'Newport', 'Rhondda Cynon Taf', 'Torfaen', 'Vale of Glamorgan'
        ]
      }
    }
  },
  Scotland: {
    regions: {
      'Highlands and Islands': {
        councils: [
          'Argyll and Bute', 'Comhairle nan Eilean Siar', 'Highland', 'Moray',
          'Orkney Islands', 'Shetland Islands'
        ]
      },
      'North East Scotland': {
        councils: [
          'Aberdeen City', 'Aberdeenshire', 'Angus', 'Dundee City'
        ]
      },
      'Central Scotland': {
        councils: [
          'Clackmannanshire', 'Falkirk', 'Fife', 'Perth and Kinross', 'Stirling'
        ]
      },
      'Glasgow and West': {
        councils: [
          'East Dunbartonshire', 'East Renfrewshire', 'Glasgow City', 'Inverclyde',
          'North Ayrshire', 'North Lanarkshire', 'Renfrewshire', 'South Lanarkshire',
          'West Dunbartonshire'
        ]
      },
      'Edinburgh and Lothians': {
        councils: [
          'City of Edinburgh', 'East Lothian', 'Midlothian', 'West Lothian'
        ]
      },
      'South Scotland': {
        councils: [
          'Dumfries and Galloway', 'East Ayrshire', 'Scottish Borders', 'South Ayrshire'
        ]
      }
    }
  },
  'Northern Ireland': {
    regions: {
      'Greater Belfast': {
        councils: [
          'Antrim and Newtownabbey', 'Ards and North Down', 'Belfast', 'Lisburn and Castlereagh'
        ]
      },
      'North': {
        councils: [
          'Causeway Coast and Glens', 'Mid and East Antrim'
        ]
      },
      'West': {
        councils: [
          'Derry City and Strabane', 'Fermanagh and Omagh'
        ]
      },
      'South': {
        councils: [
          'Armagh City, Banbridge and Craigavon', 'Mid Ulster', 'Newry, Mourne and Down'
        ]
      }
    }
  }
};

const getCountries = () => Object.keys(UK_GEOGRAPHY);

const getRegions = (country) => {
  if (!country || !UK_GEOGRAPHY[country]) return [];
  return Object.keys(UK_GEOGRAPHY[country].regions);
};

const getCouncils = (country, region) => {
  if (!country || !region || !UK_GEOGRAPHY[country]) return [];
  const regionData = UK_GEOGRAPHY[country].regions[region];
  return regionData ? regionData.councils : [];
};

const getAllCouncils = (country) => {
  if (!country || !UK_GEOGRAPHY[country]) return [];
  const councils = [];
  Object.values(UK_GEOGRAPHY[country].regions).forEach(region => {
    councils.push(...region.councils);
  });
  return councils.sort();
};

const findCouncilInfo = (councilName) => {
  for (const [country, data] of Object.entries(UK_GEOGRAPHY)) {
    for (const [region, regionData] of Object.entries(data.regions)) {
      if (regionData.councils.includes(councilName)) {
        return { country, region, council: councilName };
      }
    }
  }
  return null;
};

const COUNCIL_COORDINATES = {
  'Westminster': { lat: 51.4975, lng: -0.1357, boundaryId: 1 },
  'Camden': { lat: 51.5290, lng: -0.1255, boundaryId: 2 },
  'Manchester': { lat: 53.4808, lng: -2.2426 },
  'Birmingham': { lat: 52.4862, lng: -1.8904 },
  'Leeds': { lat: 53.8008, lng: -1.5491 },
  'Glasgow City': { lat: 55.8642, lng: -4.2518 },
  'City of Edinburgh': { lat: 55.9533, lng: -3.1883 },
  'Liverpool': { lat: 53.4084, lng: -2.9916 },
  'Bristol': { lat: 51.4545, lng: -2.5879 },
  'Sheffield': { lat: 53.3811, lng: -1.4701 },
  'Newcastle upon Tyne': { lat: 54.9783, lng: -1.6178 },
  'Nottingham': { lat: 52.9548, lng: -1.1581 },
  'Leicester': { lat: 52.6369, lng: -1.1398 },
  'Cardiff': { lat: 51.4816, lng: -3.1791 },
  'Belfast': { lat: 54.5973, lng: -5.9301 },
  'Swansea': { lat: 51.6214, lng: -3.9436 },
  'Aberdeen City': { lat: 57.1497, lng: -2.0943 },
  'Dundee City': { lat: 56.4620, lng: -2.9707 },
  'Rutland': { lat: 52.6583, lng: -0.6396 },
  'Cornwall': { lat: 50.2660, lng: -5.0527 },
  'Highland': { lat: 57.4778, lng: -4.2247 },
  'Pembrokeshire': { lat: 51.8503, lng: -4.9172 },
  'Derry City and Strabane': { lat: 55.0061, lng: -7.3286 },
  'Fermanagh and Omagh': { lat: 54.3438, lng: -7.6315 },
  'Dumfries and Galloway': { lat: 55.0700, lng: -3.6051 },
  'Argyll and Bute': { lat: 56.2540, lng: -5.0527 },
  'Brighton and Hove': { lat: 50.8225, lng: -0.1372 },
  'Southampton': { lat: 50.9097, lng: -1.4044 },
  'Portsmouth': { lat: 50.8198, lng: -1.0880 },
  'Plymouth': { lat: 50.3755, lng: -4.1427 },
  'Bournemouth, Christchurch and Poole': { lat: 50.7192, lng: -1.8808 },
  'Northumberland': { lat: 55.2082, lng: -2.0784 },
  'County Durham': { lat: 54.7753, lng: -1.5849 },
  'Cumbria': { lat: 54.5772, lng: -2.7975 },
  'North Yorkshire': { lat: 54.0847, lng: -1.5151 },
  'Norfolk': { lat: 52.6139, lng: 0.8864 },
  'Suffolk': { lat: 52.1872, lng: 1.0083 },
  'Devon': { lat: 50.7156, lng: -3.5309 },
  'Somerset': { lat: 51.1051, lng: -2.9262 },
  'Wiltshire': { lat: 51.3492, lng: -1.9927 },
  'Oxfordshire': { lat: 51.7520, lng: -1.2577 },
  'Cambridgeshire': { lat: 52.3050, lng: 0.1219 },
  'Essex': { lat: 51.7343, lng: 0.4691 },
  'Kent': { lat: 51.2787, lng: 0.5217 },
  'Surrey': { lat: 51.3148, lng: -0.5600 },
  'Hertfordshire': { lat: 51.8098, lng: -0.2377 },
  'Buckinghamshire': { lat: 51.8137, lng: -0.8095 },
  'Worcestershire': { lat: 52.1920, lng: -2.2235 },
  'Warwickshire': { lat: 52.2819, lng: -1.5849 },
  'Staffordshire': { lat: 52.8793, lng: -2.0572 },
  'Derbyshire': { lat: 53.1332, lng: -1.5631 },
  'Lincolnshire': { lat: 53.2342, lng: -0.5382 },
  'Nottinghamshire': { lat: 53.1332, lng: -0.9936 },
  'Leicestershire': { lat: 52.7726, lng: -1.2052 },
  'Lancashire': { lat: 53.8476, lng: -2.5847 },
  'Powys': { lat: 52.2555, lng: -3.4140 },
  'Ceredigion': { lat: 52.2185, lng: -3.9316 },
  'Gwynedd': { lat: 52.9285, lng: -3.8877 },
  'Anglesey': { lat: 53.2833, lng: -4.3333 },
  'Conwy': { lat: 53.2800, lng: -3.8300 },
  'Fife': { lat: 56.2082, lng: -3.1495 },
  'Perth and Kinross': { lat: 56.3950, lng: -3.4308 },
  'Angus': { lat: 56.7300, lng: -2.9200 },
  'Moray': { lat: 57.6493, lng: -3.3174 },
  'Inverness': { lat: 57.4778, lng: -4.2247 },
  'Orkney Islands': { lat: 58.9809, lng: -2.9605 },
  'Shetland Islands': { lat: 60.3913, lng: -1.2195 }
};

const getCouncilCoordinates = (councilName) => {
  return COUNCIL_COORDINATES[councilName] || null;
};

export {
  UK_GEOGRAPHY,
  getCountries,
  getRegions,
  getCouncils,
  getAllCouncils,
  findCouncilInfo,
  getCouncilCoordinates,
  COUNCIL_COORDINATES
};
